export const PAYMENT_METHOD_TOGGLE_OPTIONS = [
  { key: "COD", label: "Cash On Delivery" },
  { key: "APPLE", label: "Apple Pay" },
  { key: "CARD", label: "Card" },
  { key: "CARD_ON_DELIVERY", label: "Card On Delivery" },
  { key: "MOKAFAA", label: "MOKAFAA" },
  { key: "LOYALTY_POINTS", label: "LOYALTY POINTS" },
  { key: "WALLET", label: "WALLET" },
  { key: "PAYTABS", label: "PAYTABS" },
  { key: "FULL_DISCOUNT_OR_REWARDS", label: "FULL DISCOUNT OR REWARDS" },
  { key: "FULL_DISCOUNT", label: "FULL DISCOUNT" },
]

/** DB codes → i18n keys (same mapping as brand details). */
export const PAYMENT_METHOD_LABELS = {
  COD: "Cash On Delivery",
  APPLE: "Apple Pay",
  CARD: "Card",
  CARD_ON_DELIVERY: "Card On Delivery",
  MOKAFAA: "Mokafaa Points",
  ALRAJHI_BANK: "Mokafaa Points",
  LOYALTY_POINTS: "Loyalty Points",
  LOYALTY_REWARDS: "Loyalty Points",
  WALLET: "WALLET",
  PAYTABS: "PAYTABS",
  FULL_DISCOUNT_OR_REWARDS: "FULL DISCOUNT OR REWARDS",
  FULL_DISCOUNT: "Full Discount",
}

export const formatPaymentMethodLabels = (methods, t) => {
  if (!Array.isArray(methods) || methods.length === 0) {
    return null
  }
  return methods
    .map(method => t(PAYMENT_METHOD_LABELS[method] || method))
    .join(", ")
}

export const defaultPaymentMethodValues = PAYMENT_METHOD_TOGGLE_OPTIONS.reduce(
  (acc, option) => {
    acc[option.key] = false
    return acc
  },
  {}
)
